export const SERVICE_TABLE_HEADINGS = ["ID", "Status", "Created Date"];
export const SERVICE_TABLE_DATA_KEYS = ["_id", "status", "createdAt"];